<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>
<style lang="scss">
//input框样式
.edit_common_form{
     // 设置输入框的宽度
    .el-form-item__content {
        width: 230px;
    }
    .el-range-editor--small.el-input__inner{
        width: 230px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 230px;
    }
    .el-select{
        width: 230px;
    }
    .el-textarea{
        width:600px;
    }
    .longWidth{
          .el-radio-group{
            width:500px
          }
          .el-radio{
              padding:5px;
          }
          .el-input{
              width:210px
          }

          .el-checkbox-group{
               width: 500px;
          }
    }
    .commonWidth{
        width:560px;
        .el-form-item__content {
            width: 360px;
        }
        .el-input{
              width:230px
          }
    }
    .common_address_info{
            .el-form-item__content {
                width: 570px;
            }
            .el-select{
                // width:162px;
                width:185px;
            }
     }
    ._editor {
        width: 100%;
        .el-form-item__content {
        width: 100%;
        .document-editor {
            border: 1px solid #c4c4c4;
            .document-editor__toolbar {
                border: 0;
                border-bottom: 1px solid #c4c4c4;
                .ck-toolbar {
                    border: 0;
                }
            }
            .document-editor__editable {
            min-height: 400px;
            border: 0;
            }
        }
        }
    }
    
} 

</style>
<script>
import { removeWatermark, setWaterMark } from '@/common/watermark'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted(){
    this.setWM()
  },
  methods: {
    // 设置水印
    setWM(){
      if(this.baseUrl.indexOf('cn') != -1){
        setWaterMark('测试环境','quanyizhan.cn')
      }
    },
    //刷新当前页面事件  
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
    @import "../static/css/main.css";
    @import "../static/css/theme-green/color-green.css"; 
 
    /* 让表格表头和内容对齐 */
    body .el-table th.gutter{
        display: table-cell!important;
    }
    body .el-table th {
        display: table-cell!important; 
    }
    body .el-tooltip__popper{max-width:20%;line-height:20px;}

  /* 滚动条样式 */
  .test {
  overflow: auto;
  border  : none;
  }
  .test-1::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  }
  .test-1::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #C1C1C1;
  }
  .test-1::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
  }

</style>


// WEBPACK FOOTER //
// src/App.vue